import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { captureAdminApi } from '../api/captureApi';
import { reviewKeys } from '../queryKeys';

export function useCaptureSummary() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  return useQuery({
    queryKey: reviewKeys.captureSummary(locationId),
    queryFn: () => captureAdminApi.getSummary(locationId),
    enabled: !!locationId,
    staleTime: 2 * 60 * 1000,
  });
}
